import React, { useEffect, useState } from "react";
import { McInput } from "@maersk-global/mds-react-wrapper/mc-input";
import { format,toZonedTime } from "date-fns-tz"; 
import "../styles/LeadAndExecute.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Switch,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import apiClient from "../api/apiClient";
import ProjectStatus from "./ProjectStatus";
import { apiUrl } from "../authconfig";
const LeadForm = ({currentModalData,handleClose,setCurrentModalData}) => {
    const [isViewMore ,setIsViewMore] = useState(false)
    const [projectPhaseData, setProjectPhaseData] = useState();
    const [leadFormData,setLeadFormData] = useState([]);
    const currentUser = JSON.parse(sessionStorage.getItem("user"));
      const [cancelReason, setCancelReason] = useState();
      const [notInCurrentScopeReason, setNotInCurrentScopeReason] = useState();

    useEffect(() => {
      setProjectPhaseData(currentModalData);
    },[currentModalData])

    useEffect(() => {
      if (currentModalData?.opportunityReference) {
        apiClient
          .get(
            `${apiUrl}/api/lead-opportunities/reference/${currentModalData.opportunityReference}`
          )
          .then((response) => {
            setLeadFormData(response.data);
          })
          .catch((error) => {
            console.error("Error fetching product data:", error);
          });
      }
    }, [currentModalData?.projectId]);

    const handleSaveClick = (e) => {
       if (
    (projectPhaseData?.projectStatus === "Cancelled" && !cancelReason) ||
    (projectPhaseData?.projectStatus === "Not in Current Scope" && !notInCurrentScopeReason)
  ) {
    alert("Please select a further reason for the current project status selected. ");
    return;
  }
       if (
       (projectPhaseData?.projectStatus == 'Cancelled' || projectPhaseData?.projectStatus == 'Not in Current Scope') ||
        (projectPhaseData?.estimatedGoLiveDate && projectPhaseData?.estimatedHypercareEndDate && projectPhaseData?.actualGoLiveDate && projectPhaseData?.projectStatus)
        
       ) {
         apiClient
           .post(
             `${apiUrl}/api/opportunities/save`,
             {...projectPhaseData, modifiedBy:currentUser?.mail,
                projectSubstatus:
                projectPhaseData?.projectStatus === "Cancelled"
                  ? cancelReason
                  : projectPhaseData?.projectStatus === "Not in Current Scope"
                  ? notInCurrentScopeReason
                  : null,
              modifiedDate: format(toZonedTime(new Date(), "Europe/Copenhagen"), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")}
           )
           .then((response) => {
             console.log(response);
              setCurrentModalData({
            ...projectPhaseData,
          });
             alert("Data saved successfully");
             handleClose();
           })
           .catch((error) => {
              if (error.response) {
                  if (error.response.status === 403) {
                    alert("Please fill all mandatory fields");
                  } else if (error.response.status === 400) {
                    alert(error.response.data || "Bad request");
                  } else {
                    alert("An error occurred. Please try again.");
                  }
                  console.log("error", error);
                } else {
                  alert("An error occurred. Please try again.");
                  console.log("error", error);
                }
              });
       }
       else{
         alert("Please fill the estimated Golive Date, Actual Golive Date and Estimated Hypercare end date")
       }
     };
  
return (

  <div>
    <div className="Project" style={{ color: "rgb(0, 36, 61)" }}>
      Project Details
    </div>
    <div
      style={{
        display: "flex",
        width: "100%",
        gap: "25px",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Project ID</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.projectId || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Opportunity Closed Won Date</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.closedWonDate || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Opportunity Reference</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.opportunityReference || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Account Name</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.accountName || ""}
          ></McInput>
        </div>
      </div>
    </div>
    {!isViewMore &&  <div style={{fontSize:'12px',display:'flex',alignItems:'center',cursor:'pointer'}} onClick={()=> setIsViewMore(true)}><AddIcon/>View More</div>}
   { isViewMore && <>
    <div
      style={{
        display: "flex",
        width: "100%",
        gap: "25px",
        justifyContent: "space-between",
        paddingTop: "10px",
      }}
    >
       <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Agreement End Date</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.agreementEndDate || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Opportunity Type</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.opportunityType || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Country Role</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.countryRole || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Agreement Start Date</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.agreementStartDate || ""}
          ></McInput>
        </div>
      </div>
    </div>
    <div
      style={{
        display: "flex",
        width: "100%",
        gap: "25px",
        justifyContent: "space-between",
        paddingTop: "10px",
      }}
    >
     
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Gross Profit (USD)</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.grossProfit || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Total Revenue</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.totalRevenue || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Opportunity Owner Country</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.opportunityOwnerCountry || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Service Contract Number</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.serviceContractNumber || ""}
          ></McInput>
        </div>
      </div>
    </div>
    <div
      style={{
        display: "flex",
        width: "100%",
        gap: "25px",
        justifyContent: "space-between",
        paddingTop: "10px",
      }}
    >
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Customer SCV code</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.customerScvCode || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Opportunity Name</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.opportunityName || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Opportunity Owner</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.opportunityOwner || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Closed Won Date</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.closedWonDate || ""}
          ></McInput>
        </div>
      </div>
    </div>
    <div
      style={{
        display: "flex",
        width: "100%",
        gap: "25px",
        justifyContent: "space-between",
        paddingTop: "10px",
      }}
    >
    
    
      <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Vertical</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.vertical || ""}
          ></McInput>
        </div>
      </div>
       <div style={{ display: "flex", width: "25%" }}>
        <div className="DetailsLabel">Brand</div>
        <div className="DetailsLabel">
          <McInput
            className="inputReadonly"
            hiddenlabel="true"
            fit="small"
            readonly={true}
            value={currentModalData?.brand || ""}
          ></McInput>
        </div>
      </div>
      <div style={{ display: "flex", width: "25%" }}></div>
         <div style={{ display: "flex", width: "25%" }}></div>
    </div>
    </> 
    }
  { isViewMore && <div style={{fontSize:'12px',display:'flex',alignItems:'center',cursor:'pointer'}} onClick={()=> setIsViewMore(false)}><RemoveIcon/>View Less</div>}
    <div>
<div className="Project" style={{ color: "rgb(0, 36, 61)",marginTop:'20px' }}>Product Details </div>
             <div style={{width: "100%" }}>
             <TableContainer component={Paper}>
          <Table className="ProjectStatusTable">
          <TableHead sx={{ backgroundColor: "#ededed", color: "black" }}>
  <TableRow>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Product Family</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Product</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Project ID</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Total Quantity</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>UOM</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Product Gross Profit</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Product Revenue</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Executing Country</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Stn. Weekly Volume</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Avg Weekly Volume</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Project Phase</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Project Status</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Detailed Reason For Not to Track</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Party Responsible Not to Track</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Support Required Form</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Go live Date</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>HyperCare Date</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Volume Conversion(%)</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Comments on low volume</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Assigned User</TableCell>
    <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Assign Functions</TableCell>
  </TableRow>
</TableHead>
            <TableBody style={{ backgroundColor: "white", color: "black" }}>
              {leadFormData.map((product, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ textAlign: "center" }}>{product?.productBundles}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.product}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.projectId}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.totalQuantity}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.uom}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.productGrossProfit}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.productRevenue}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.executingCountry}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.scheduledWeeklyVolume}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.averageActualWeeklyVolume}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.projectPhase}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.projectStatus}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.detailReasonForNotOnTrack}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.partyResponsibleForNotOnTrack}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.supportRequiredFrom}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.estimatedGoLiveDate}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.estimatedHypercareEndDate}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.volumeConv}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.commentsOnLowVolume}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.assignedUser}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{product?.assignedToFunction}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
          </div>
    </div>
    <div className="Project">
      <div style={{ display: "flex", gap: "10px", paddingTop: "10px" }}>
        <div  style={{width:'100%'}}>
          <div
            style={{
              color: "rgb(0, 36, 61)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
              position: "sticky",
              top: 0,
              background: "white",
              borderBottom: "1px solid #ccc",
              zIndex: "1",
            }}
          >
            <div className="ProjectTitle" style={{marginTop:'10px'}}>OverAll Project Status </div>
            <div style={{ textAlign: "right" }}>
              <Button
              className="closePhaseButton"
                style={{
                  padding: "0 10px",
                  width: "max-content",
                  backgroundColor: "rgb(0, 36, 61)",
                  position: "sticky",
                }}
                variant="contained"
                onClick={(e) => handleSaveClick(e)}
                disabled={currentModalData?.projectStatus == 'Cancelled' || currentModalData?.projectStatus == 'Not in Current Scope' || currentModalData?.projectStatus == 'Complete' || currentModalData?.assignedUser != currentUser?.mail}
              >
                Save Details
              </Button>
            </div>
          </div>
          <div style={{ flex: 1, border: "1px solid #ccc", padding: "10px" }}>
            <ProjectStatus
              projectPhaseData={projectPhaseData}
              isLiteModal={true}
              setProjectPhaseData={setProjectPhaseData}
              currentModalData={currentModalData}
               cancelReason={cancelReason}
                setCancelReason={setCancelReason}
                notInCurrentScopeReason={notInCurrentScopeReason}
                setNotInCurrentScopeReason={setNotInCurrentScopeReason}
            />
          </div>
        </div>
      </div>
    </div>
    
  </div>
)
}



export default LeadForm
